export const fixedDepositsConstants = {
  FIXED_DEPOSITS_LIST_REQUEST: "FIXED_DEPOSITS_LIST_REQUEST",
  FIXED_DEPOSITS_LIST_COMPLETE: "FIXED_DEPOSITS_LIST_COMPLETE",
  FIXED_DEPOSITS_LIST_ERROR: "FIXED_DEPOSITS_LIST_ERROR",

  FIXED_DEPOSITS_RATE_LIST_REQUEST: "FIXED_DEPOSITS_RATE_LIST_REQUEST",
  FIXED_DEPOSITS_RATE_LIST_COMPLETE: "FIXED_DEPOSITS_RATE_LIST_COMPLETE",
  FIXED_DEPOSITS_RATE_LIST_ERROR: "FIXED_DEPOSITS_RATE_LIST_ERROR",

  FIXED_DEPOSITS_PRODUCT_DETAILS_REQUEST:
    "FIXED_DEPOSITS_PRODUCT_DETAILS_REQUEST",
  FIXED_DEPOSITS_PRODUCT_DETAILS_ERROR: "FIXED_DEPOSITS_PRODUCT_DETAILS_ERROR",
  FIXED_DEPOSITS_PRODUCT_DETAILS_COMPLETE:
    "FIXED_DEPOSITS_PRODUCT_DETAILS_COMPLETE",

  FIXED_DEPOSITS_OPEN_INITIATE_REQUEST: "FIXED_DEPOSITS_OPEN_INITIATE_REQUEST",
  FIXED_DEPOSITS_OPEN_INITIATE_ERROR: "FIXED_DEPOSITS_OPEN_INITIATE_ERROR",
  FIXED_DEPOSITS_OPEN_INITIATE_COMPLETE:
    "FIXED_DEPOSITS_OPEN_INITIATE_COMPLETE",

  FIXED_DEPOSITS_ELIGIBLE_CASA_LIST_REQUEST:
    "FIXED_DEPOSITS_ELIGIBLE_CASA_LIST_REQUEST",
  FIXED_DEPOSITS_ELIGIBLE_CASA_LIST_COMPLETE:
    "FIXED_DEPOSITS_ELIGIBLE_CASA_LIST_COMPLETE",
  FIXED_DEPOSITS_ELIGIBLE_CASA_LIST_ERROR:
    "FIXED_DEPOSITS_ELIGIBLE_CASA_LIST_ERROR",

  SET_FIXED_DEPOSIT_PRODUCT_TYPE: "SET_FIXED_DEPOSIT_PRODUCT_TYPE",

  SET_FIXED_DEPOSIT_PRODUCT_CODE: "SET_FIXED_DEPOSIT_PRODUCT_CODE",
  SET_FIXED_DEPOSIT_PAYABLE_METHOD: "SET_FIXED_DEPOSIT_PAYABLE_METHOD",

  SET_FIXED_DEPOSITS_ELIGIBLE_CASA_ACCOUNT:
    "SET_FIXED_DEPOSITS_ELIGIBLE_CASA_ACCOUNT",

  SET_FIXED_DEPOSITS_AUTOMATIC_RENEWAL: "SET_FIXED_DEPOSITS_AUTOMATIC_RENEWAL",

  SET_FIXED_DEPOSITS_ELIGIBLE_INTEREST_PAYABLE_CASA_ACCOUNT:
    "SET_FIXED_DEPOSITS_ELIGIBLE_INTEREST_PAYABLE_CASA_ACCOUNT",

  SET_FIXED_DEPOSITS_PRINCIPAL_AMOUNT: "SET_FIXED_DEPOSITS_PRINCIPAL_AMOUNT",

  SET_FIXED_DEPOSITS_MATURITY_AMOUNT: "SET_FIXED_DEPOSITS_MATURITY_AMOUNT",

  SET_FIXED_DEPOSITS_INTEREST_AMOUNT: "SET_FIXED_DEPOSITS_INTEREST_AMOUNT",

  SET_FIXED_DEPOSIT_OPEN_INITIATE: "SET_FIXED_DEPOSIT_OPEN_INITIATE",

  FIXED_DEPOSITS_OTP_CONFIRMATION_REQUEST:
    "FIXED_DEPOSITS_OTP_CONFIRMATION_REQUEST",
  FIXED_DEPOSITS_OTP_CONFIRMATION_ERROR:
    "FIXED_DEPOSITS_OTP_CONFIRMATION_ERROR",
  FIXED_DEPOSITS_OTP_CONFIRMATION_COMPLETE:
    "FIXED_DEPOSITS_OTP_CONFIRMATION_COMPLETE",

  FIXED_DEPOSITS_RECEIPT_REQUEST: "FIXED_DEPOSITS_RECEIPT_REQUEST",
  FIXED_DEPOSITS_RECEIPT_ERROR: "FIXED_DEPOSITS_RECEIPT_ERROR",
  FIXED_DEPOSITS_RECEIPT_COMPLETE: "FIXED_DEPOSITS_RECEIPT_COMPLETE",

  FIXED_DEPOSITS_OTP_RESEND_REQUEST: "FIXED_DEPOSITS_OTP_RESEND_REQUEST",
  FIXED_DEPOSITS_OTP_RESEND_ERROR: "FIXED_DEPOSITS_OTP_RESEND_ERROR",
  FIXED_DEPOSITS_OTP_RESEND_COMPLETE: "FIXED_DEPOSITS_OTP_RESEND_COMPLETE",

  FIXED_DEPOSITS_OTP_RESEND_REQUEST: "FIXED_DEPOSITS_OTP_RESEND_REQUEST",
  FIXED_DEPOSITS_OTP_RESEND_ERROR: "FIXED_DEPOSITS_OTP_RESEND_ERROR",
  FIXED_DEPOSITS_OTP_RESEND_COMPLETE: "FIXED_DEPOSITS_OTP_RESEND_COMPLETE",

  CLEAR_FIXED_DEPOSITS: "CLEAR_FIXED_DEPOSITS",
  SET_FIXED_DEPOSIT_PERIOD: "SET_FIXED_DEPOSIT_PERIOD",

  CLEAR_FIXED_DEPOSITS_RECEIPT: "CLEAR_FIXED_DEPOSITS_RECEIPT",

  FIXED_DEPOSITS_ONLINE_CHANNEL: "INTERNET",
};
